<template>
  <FormBody :number="1">
    <div class="feedback-types-wrap">
      <h3 class="feedback-types__title text-center">Выберите причину обращения</h3>
        <ul class="feedback-types__list">
          <li class="feedback-types__element"  @click="onContractClick('insuredEventClaim', 'insuredEventClaim')"><span class="feedback-types__link">Заявить страховое событие</span></li>
          <li class="feedback-types__element"  @click="onContractClick('insuredEventClaim', 'insuredEventClaim', { SurvivalMode: true })"><span class="feedback-types__link">Дожитие</span></li>
          <li class="feedback-types__element" @click="onContractClick('TerminateContractClick', 'personalDataForm')"><span  class="feedback-types__link">Расторгнуть договор страхования</span></li>
          <li class="feedback-types__element" @click="onContractClick('RenewContract', 'personalDataForm')"><span class="feedback-types__link">Продлить договор страхования</span></li>
          <li class="feedback-types__element" @click="onContractClick('SendAdditionalDocuments', 'personalDataForm')"><span class="feedback-types__link">Прислать дополнительные документы</span></li>
          <li class="feedback-types__element" @click="onContractClick('GetFeedback', 'personalDataForm')"><span  class="feedback-types__link">Получить обратную связь по отзыву</span></li>
          <li class="feedback-types__element" @click="onContractClick('Other', 'personalDataForm')"><span  class="feedback-types__link">Другое</span></li>
        </ul>
    </div>
  </FormBody>
</template>

<script>
import FormBody from "@/components/utils/FormBody";
import {mapMutations} from "vuex";
import * as mns from '@/store/mutation-types';
import config from '@/config';



export default {
  anotherNameLife: "Home",
  components: {FormBody},
  methods: {
    ...mapMutations([mns.SET_PERSONAL_FORM_TYPE,]),
    onContractClick(type, page, params){
      this[mns.SET_PERSONAL_FORM_TYPE](type);
      if (params) 
        localStorage.setItem('params', JSON.stringify(params))
      else 
        localStorage.removeItem('params')
      this.$router.push(config.folder+'/'+page);
    },
  },
  computed: {
  },
}
</script>

<style scoped>
.feedback-types__list{
  list-style-type: none;
}

.feedback-types__element{
  margin: 20px 0;
}


.feedback-types__link{
  text-align: center;
  cursor: pointer;
  margin: auto;
  width: 100%;
  max-width: 450px;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  border: 2px solid #e60028;
  border-radius: 5px;
  height: 55px;
  font-family: Source Sans Pro,Open Sans,sans-serif;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
  line-height: 15px;
  text-decoration: none;
  position: relative;
  color: #333;
  z-index: 1;
  overflow: hidden;
  transition: all .5s;
}

.feedback-types__link:hover {
  text-decoration: none;
  color: #fff;
}

.feedback-types__link:before {
  content: "";
  display: block;
  width: 100%;
  height: 200px;
  top: -50px;
  position: absolute;
  background: #e60028;
  z-index: -1;
  left: -100%;
  -webkit-transition: all .3s;
  transition: all .3s;
}

.feedback-types__link:hover:before {
  left: 0;
}


.feedback-types-wrap{
  padding: 20px;
}

@media (max-width: 400px) {
  .feedback-types__link{
    font-size: 14px;
    height: 45px;
  }
}


</style>